import {Dispatch} from "redux";

import {catch400, catch403, patchRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {applicationCreateTypes} from "../actions/application_form_actions";
import {ConsumerSegment} from "../types/ConsumerSegment";
import {IApplication} from "../types/IApplication";
import {alertFormSuccessMessage} from "../utils/alert_text";

interface IExtendedApplication extends IApplication {
    consumer_segment: ConsumerSegment;
}

const applicationPatchApiLink = apiLink.application.detail;
export const patchApplication = (uuid: string, jsonData: Partial<IExtendedApplication>, storeHash: string) => (dispatch: Dispatch) => {
    dispatch({type: applicationCreateTypes.start, id: storeHash});

    return patchRequest({}, applicationPatchApiLink({})({uuid}), jsonData)
        .then((application: IApplication) => {
            dispatch({type: applicationCreateTypes.success, id: storeHash, result: application});
            dispatch(addSuccessNotification(alertFormSuccessMessage));
            return application;
        })
        .catch(
            catch400((error) => {
                dispatch({type: applicationCreateTypes.error, id: storeHash, error: error.appError});
                console.error("Popraw błędy formularza");
            })
        )
        .catch(
            catch403((err) => {
                dispatch({type: applicationCreateTypes.error, id: storeHash, error: null});
                notifyBugsnag(err, "applicationPatch: catch 403", err.responseError ?? {});
            })
        );
};
import {Dispatch} from "redux";

import {catch400, catch403, patchRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {applicationCreateTypes} from "../actions/application_form_actions";
import {ConsumerSegment} from "../types/ConsumerSegment";
import {IApplication} from "../types/IApplication";
import {alertFormSuccessMessage} from "../utils/alert_text";

interface IExtendedApplication extends IApplication {
    consumer_segment: ConsumerSegment;
}

const applicationPatchApiLink = apiLink.application.detail;
export const patchApplication = (uuid: string, jsonData: Partial<IExtendedApplication>, storeHash: string) => (dispatch: Dispatch) => {
    dispatch({type: applicationCreateTypes.start, id: storeHash});

    return patchRequest({}, applicationPatchApiLink({})({uuid}), jsonData)
        .then((application: IApplication) => {
            dispatch({type: applicationCreateTypes.success, id: storeHash, result: application});
            dispatch(addSuccessNotification(alertFormSuccessMessage));
            return application;
        })
        .catch(
            catch400((error) => {
                dispatch({type: applicationCreateTypes.error, id: storeHash, error: error.appError});
                console.error("Popraw błędy formularza");
            })
        )
        .catch(
            catch403((err) => {
                dispatch({type: applicationCreateTypes.error, id: storeHash, error: null});
                notifyBugsnag(err, "applicationPatch: catch 403", err.responseError ?? {});
            })
        );
};
